import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../theming/useTheme';

const componentConfigurationKey = 'decorationLine';

interface DecorationLineComponentThemeProps {
  cardDecorationColor: string
}

const getDecorationLineStyle = (cardDecorationColor: string) => {
  return StyleSheet.create({
    style: {
      height: '2px',
      width: '100%',
      backgroundColor: cardDecorationColor,
    },
  });
};

export const DecorationLineComponent: React.FunctionComponent<DecorationLineComponentThemeProps> = props => {
  const { cardDecorationColor } = props;
  const decorationLineStyle = getDecorationLineStyle(cardDecorationColor);
  return (<div className={css(decorationLineStyle.style)} />);
};

const mapThemeToProps = (theme: DecorationLineComponentThemeProps) => ({
  cardDecorationColor: theme.cardDecorationColor,
});

export const DecorationLine = (props: {}) => {
  const themeContext = useTheme(componentConfigurationKey, mapThemeToProps);
  return <DecorationLineComponent {...themeContext} {...props} />;
};
